import { useState } from 'react';

import { Icon } from '@atom/mui';
import { ImageIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

type MediaImageThumbnailProps = {
  fileId: string;
  name: string;
};

const MediaImageThumbnail = ({ fileId, name }: MediaImageThumbnailProps) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <Icon color={colors.brand.blue} icon={ImageIcon} />;
  }

  return (
    <img
      style={{ width: '24px', height: '24px' }}
      src={`${FILES_ENDPOINT}/${fileId}_24`}
      alt={name}
      onError={() => setFailed(true)}
    />
  );
};

export default MediaImageThumbnail;
